<!--
 * @Author: DXG
 * @Date: 2024-05-09 09:50:01
 * @LastEditors: situgen@szkingdom.com
 * @LastEditTime: 2025-07-13 13:25:07
 * @FilePath: \kdtup-pc-web\src\components\fund\belongToConsignment.vue
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
-->
<template>
    <div class="belongTo-dialog">
        <el-dialog
            class="el-dialog-contain prop"
            title="快速开通网上交易"
            :visible.sync="confirmDialog"
            width="780px"
            :show-close="true"
            :close-on-press-escape="false"
            :close-on-click-modal="false"
        >
            <div class="confirm-container confirm-order-text">
                {{ title }}
            </div>
            <!-- <div class="confirm-container openacct-text">
                {{ message }}
            </div> -->
            <div class="button-container">
                <div style="margin: 0 auto">
                    <div class="btn-confirm cancel" v-on:click="closeDialog">取消</div>
                    <div class="btn-confirm" v-on:click="toOpenPage">立即开通</div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Router from "@/router";
export default {
    data() {
        return {
            confirmDialog: false,
            title: "",
            message: ""
        };
    },
    created() {},
    methods: {
        openDialog(title, message) {
            this.confirmDialog = true;
            this.title = title || "抱歉！您尚未开通网上交易，开通后才能执行本操作。";
            // this.message =
            //     message ||
            //     `网上交易安全、快捷、费率低、到账快，更有省钱购、${this.$const.getXJBParam(
            //         "name"
            //     )}、智能定投、赎回转认/申购等多项个性化功能为您提供服务。`;
        },
        toOpenPage() {
            this.confirmDialog = false;
            // 统一跳转到【新开交易账号与绑定已有交易账号】选择页
            Router.push({
                name: "bindacctway"
            });
        },
        closeDialog() {
            this.confirmDialog = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.confirm-container {
    width: 92%;
    margin: 0 auto;
    height: auto;
}
::v-deep .el-dialog__header {
    color: #000;
    background-color: #eeeeee;
    font-weight: bold;
}
.confirm-order-text {
    font-family: Source Han Sans CN, sans-serif;
    font-size: 20px;
    line-height: 40px;
    letter-spacing: 0px;
    text-align: center;
    margin: 39.74px 20px 20px;
    color: $bg18;
}
.button-container {
    width: 100%;
    text-align: center;
    .btn-confirm {
        display: inline-block;
        color: #fff;
        background-color: $bg18;
        width: 180px;
        margin: 30px auto 10px;
        padding: 10px 0;
        text-align: center;
        font-size: 16px;
        margin-right: 40px;
        cursor: pointer;
        &:hover {
            opacity: 0.7;
        }
    }
    .cancel {
        color: #333;
        background: #e4e4e4;
    }
}
.confirm-btn {
    display: flex;
}
.openacct-text {
    width: 80%;
    padding: 23px 47px 29px 41px;
    background: #f9f9f9;
    font-size: 18px;
    line-height: 180%;
}
</style>
